module.exports = __webpack_public_path__ + "static/media/wide-logo-upload.45c65c50.svg";